<template>
	<div class="wages wrapper shadow">
		<div class="operation">
			<div class="left">
				<div class="main-title">部门月度工资明细表</div>
			</div>
			<div class="right">
				<el-date-picker class="department" v-model="query.month" type="month" placeholder="请选择月份"
					format="YYYY-MM" value-format="YYYY-MM-DD" />
				<el-select class="department" v-model="query.departmentId" placeholder="请选择部门">
					<el-option v-for="item in departmentOptions" :key="item.value" :label="item.label"
						:value="item.value" />
				</el-select>
				<el-button type="primary" @click="getList">查询</el-button>
				<el-button type="primary" @click="exportSubmitForm">导出</el-button>
                <el-button type="primary" @click="calcReport">计算报表工资</el-button>
                <el-button type="primary" @click="reportView(1)">签字表打印(不带补贴)</el-button>
                <el-button type="primary" @click="reportView(2)">补贴表打印</el-button>
                <el-button type="primary" @click="reportView(3)">财务报表打印</el-button>
			</div>
		</div>
		<!-- 表格 -->
		<el-table class="table" header-row-class-name="main-table-header" :data="tableData" border height="670">
			<el-table-column label="工资表" align="center">
				<el-table-column :label="'部门：' + query.department" align="left">
					<el-table-column prop="person.name" label="姓名" min-width="100" fixed align="center" />
					<el-table-column prop="person.idCard" label="身份证号" min-width="100" fixed align="center">
                        <template #default="scope">
                            <span style="color: white">'</span><span>{{scope.row.person.idCard}}</span>
                        </template>
                    </el-table-column>
					<el-table-column label="基本工资" min-width="100" prop="baseSalary" align="center">
					</el-table-column>
					<el-table-column label="工资加项" align="center">
						<el-table-column label="工龄" min-width="70" align="center" prop="annualLeaveAllowance" />
						<el-table-column label="绩效" min-width="80" align="center" prop="performanceSalary">
						</el-table-column>
						<el-table-column prop="performanceCoefficient" label="绩效系数(%)" min-width="120" align="center">
							<template #default="scope">
								{{(scope.row.performanceCoefficient - scope.row.performanceCoefficientDeductions).toFixed(2)}}%
							</template>
						</el-table-column>
						<el-table-column prop="mealFee,carFee" label="补助" min-width="90" align="center">
							<template #default="scope">
								<el-row class="leave-row">
									<span>餐补：</span>
									{{scope.row.mealFee}}
								</el-row>
								<el-row class="leave-row">
									<span>车补：</span>
									{{scope.row.carFee}}
								</el-row>
                                <el-row class="leave-row">
                                    <span>调整：</span>
                                    {{scope.row.subsidyAdjustment}}
                                </el-row>
							</template>
						</el-table-column>
						<el-table-column label="其他" min-width="80" align="center" prop="otherSalary">
						</el-table-column>
					</el-table-column>
					<el-table-column prop="specialAdjustment" label="特别调整" min-width="80" align="center">
					</el-table-column>
					<el-table-column prop="adjustmentReason" label="调整事由" min-width="80" align="center">
					</el-table-column>
					<el-table-column prop="payableSalary" label="应发工资" min-width="90" align="center" />
				</el-table-column>

				<el-table-column :label="query.monthStr ? (query.monthStr + '(全勤天数: ' + query.fullAttendanceDays + '天)') : ''" align="left">
					<el-table-column label="扣款项目" align="center">
						<el-table-column label="社保" min-width="70" align="center" prop="socialSecurity" />
						<el-table-column label="个税" min-width="70" align="center" prop="personalIncomeTax" />
						<el-table-column label="请假天数" min-width="120" align="center">
							<template #default="scope">
								<div class="leave">
									<el-row class="leave-row">
										<span>事假：</span>
										{{scope.row.leaveDays}}
									</el-row>
									<el-row class="leave-row">
										<span>病假：</span>
										{{scope.row.sickDays}}
									</el-row>
									<el-row class="leave-row">
										<span>婚丧假：</span>
										{{scope.row.marriageDays}}
									</el-row>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="请假扣款" min-width="220" align="center">
							<template #default="scope">
								<div class="leave deduction">
									<el-row class="leave-row">
										<span>事假：</span>
										{{scope.row.leaveDeductions}}
									</el-row>
									<el-row class="leave-row">
										<span>病假：</span>
										{{scope.row.sickDeductions}}
									</el-row>
									<el-row class="leave-row">
										<span>工龄：</span>
										{{scope.row.annualLeaveDeductions}}
									</el-row>
									<el-row class="leave-row">
										<span>餐补：</span>
										{{scope.row.mealFeeDeductions}}
									</el-row>
									<el-row class="leave-row">
										<span>车补：</span>
										{{scope.row.carFeeDeductions}}
									</el-row>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="其他" min-width="70" align="center" prop="otherDeductions"></el-table-column>
					</el-table-column>
					<el-table-column prop="actualSalary" label="实发工资" min-width="90" align="center" />
				</el-table-column>
			</el-table-column>
		</el-table>
	</div>
</template>
<script setup>
	import {
		ref
	} from "@vue/reactivity";
    import {
        fetchList,
        fetchLastMonth, calcFinReport
    } from "@/api/payroll";
	import {
		fetchList as fetchDepartmentList
	} from "@/api/department";
	import {
		onMounted
	} from "vue";

	onMounted(() => {
		getLastMonth();
		getDepartmentList();
	});

	const getLastMonth = () => {
		fetchLastMonth().then((res) => {
			query.value.month = res.data;
		});
	};

	const getList = () => {
		if (!query.value.month) {
			ElMessage({
				type: "error",
				message: "请选择月份！",
			});
			return;
		}
		if (!query.value.departmentId) {
			ElMessage({
				type: "error",
				message: "请选择部门！",
			});
			return;
		}
		query.value.department = departmentOptions.value.find(
			(item) => item.value === query.value.departmentId
		).label;
		let monthArr = query.value.month.split("-");
		query.value.monthStr = monthArr[0] + "年" + monthArr[1] + "月";
		fetchList(query.value).then((res) => {
			tableData.value = res.data.list;
			query.value.total = res.data.total;
		});
        getFullAttendanceDays(query.value.month)
	};

	//月份
	const query = ref({
		month: "",
        fullAttendanceDays: '',
		departmentId: "",
		department: "",
		keyword: "",
		sort: "-person.sort,+person.id",
		page: 1,
		pagesize: 99999,
		total: "",
	});
	import FileSaver from "file-saver";
	import XLSX from "xlsx";
    import {
        ElMessage, ElMessageBox
    } from "element-plus";

	const exportSubmitForm = async () => {
		if (tableData.value.length === 0) {
			ElMessage({
				type: "error",
				message: "请先查询数据！",
			});
			return;
		}
		var wb = XLSX.utils.table_to_book(document.querySelector(".table"));
		var wbout = XLSX.write(wb, {
			bookType: "xlsx",
			bookSST: true,
			type: "array",
		});
		try {
			FileSaver.saveAs(
				new Blob([wbout], {
					type: "application/octet-stream"
				}),
				"部门月度工资明细表-" +
				query.value.department +
				"-" +
				query.value.monthStr +
				".xlsx"
			);
		} catch (e) {
			if (typeof console !== "undefined") console.log(e, wbout);
		}
		return wbout;
	};
	// 选择部门
	const departmentOptions = ref([]);

	const getDepartmentList = () => {
		fetchDepartmentList().then((res) => {
			let list = res.data.list;
			departmentOptions.value = [];
			list.forEach((item) => {
				departmentOptions.value.push({
					value: item.id,
					label: item.name,
				});
			});
		});
	};
	// 表格
	const tableData = ref([]);

    import { fetchFullAttendanceDays } from "../../api/payroll";

    const getFullAttendanceDays = (month) => {
        fetchFullAttendanceDays({
            month: month
        }).then(res => {
            query.value.fullAttendanceDays = res.data
        })
    }

    import { useRouter } from 'vue-router'
    const router = useRouter()
    const reportView = (type) => {
        if (tableData.value.length === 0) {
            ElMessage({
                type: "error",
                message: "请先查询数据！",
            });
            return;
        }
        const { href } = router.resolve({
            path: 'report-3-print',
            query: {
                month: query.value.month,
                departmentId: query.value.departmentId,
                total: query.value.total,
                type: type
            }
        })
        window.open(href, '_blank')
    }

    const calcReport = () => {
        let month = query.value.month

        ElMessageBox.confirm("确定要重新计算报表工资吗?", "Warning", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(() => {
            calcFinReport({month: month}).then(res => {
                ElMessage({
                    showClose: true,
                    message: '计算成功',
                    type: 'success',
                    duration: 1000
                })
            })
        })
            .catch(() => {});
    }

</script>
<style lang="scss" scoped>
	.tips {
		line-height: 26px;
	}

	.leave {
		vertical-align: top !important;

		.leave-row {
			display: flex;
			align-items: center;
			flex-wrap: nowrap;
			margin: 0 0 2px 0;

			&:last-child {
				margin: 0;
			}

			span {
				width: 60px;
				text-align: right;
			}

			.el-input {
				width: 50px;
			}
		}
	}

	.deduction {
		display: flex;
		flex-wrap: wrap;

		.leave-row {
			width: 50%;

			span {
				width: fit-content !important;
			}
		}

	}
</style>
